module.exports = __webpack_public_path__ + "static/img/invite2.36ec9ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/invite2.png
// module id = 915
// module chunks = 1